/** @file Screen rectangles (marquee, box select) normalized so x0 <= x1 and y0 <= y1. */

/** Axis-aligned rectangle in screen or content pixels (y-down); corners may come in any order. */
export interface ScreenRect {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
}

/** Returns a new rect with x0 <= x1 and y0 <= y1 covering the same area. */
export function normalizeRect(r: ScreenRect): ScreenRect {
  return { x0: Math.min(r.x0, r.x1), y0: Math.min(r.y0, r.y1), x1: Math.max(r.x0, r.x1), y1: Math.max(r.y0, r.y1) };
}
